import { faHexagonExclamation, faHexagonXmark, faInfoCircle, faTriangleExclamation } from "@fortawesome/pro-light-svg-icons";
import { Box, FormHelperText } from "@mui/material";
import { BasicAlert, ErrorStylingType, FormErrorType, IAdditionalFormInputProps, IValidationError, ValidationErrorType, useErrorStyling } from "@ngt/forms";
import { IFieldInputProps } from "@ngt/forms-core";

type ErrorViewProps =  IFieldInputProps<string, any, IValidationError, string> & Omit<IAdditionalFormInputProps, "label">;

export interface IErrorViewProps extends ErrorViewProps {
    view: 'Text' | 'Alert' | 'Alerts';
}

const ErrorView: React.FunctionComponent<IErrorViewProps> = ({
    hasErrors,
    errors,
    errorType,
    view
}) => {

    const errorStyling = useErrorStyling(errorType as unknown as FormErrorType, ErrorStylingType.InputStandard);

    if(!errors || errors.length === 0) {
        return null;
    }

    if (view === 'Alert') {
        return (
            <BasicAlert
                severity={
                    errorType === ValidationErrorType.Warning ?
                        'info' :
                        errorType === ValidationErrorType.Low ?
                            'warning' :
                            errorType === ValidationErrorType.Normal ?
                                'error' :
                                errorType === ValidationErrorType.High ?
                                    'warning' :
                                    //errorType === ValidationErrorType.Critical ?
                                    'error' 
                }
                icon={
                    
                    errorType === ValidationErrorType.Warning ?
                        faInfoCircle :
                        errorType === ValidationErrorType.Low ?
                            faTriangleExclamation :
                            errorType === ValidationErrorType.Normal ?
                                faHexagonExclamation :
                                errorType === ValidationErrorType.High ?
                                    faHexagonXmark :
                                    //errorType === ValidationErrorType.Critical ?
                                    faHexagonXmark
                }
                description={
                    <>
                        {errors?.map((error, i) => (<div key={i}>{error.message}</div>))}
                    </>
                }
            />
        );
    }
    else if (view === 'Alerts') {
        return (
            <>
                
                {
                    errors?.map((error, i) => (
                        <Box key={i} sx={{mb:2}}>
                            <BasicAlert
                                severity={
                                    error.type === ValidationErrorType.Warning ?
                                        'info' :
                                        error.type === ValidationErrorType.Low ?
                                            'warning' :
                                            error.type === ValidationErrorType.Normal ?
                                                'error' :
                                                error.type === ValidationErrorType.High ?
                                                    'warning' :
                                                    //errorType === ValidationErrorType.Critical ?
                                                    'error' 
                                }
                                icon={
                                    
                                    error.type === ValidationErrorType.Warning ?
                                        faInfoCircle :
                                        error.type === ValidationErrorType.Low ?
                                            faTriangleExclamation :
                                            error.type === ValidationErrorType.Normal ?
                                                faHexagonExclamation :
                                                error.type === ValidationErrorType.High ?
                                                    faHexagonXmark :
                                                    //errorType === ValidationErrorType.Critical ?
                                                    faHexagonXmark
                                }
                                description={error.message}
                            />
                        </Box>
                    ))
                }
            </>
        )
    }

    return (
        <Box
            sx={{
                ...errorStyling
            }}
        >
            <FormHelperText>
                {errors?.map((error, i) => (<span key={i}>{error.message}</span>))}
            </FormHelperText>
        </Box>

    );
}

export default ErrorView;